<template>
  <div class="medication-request-list-view">
    <h5 class="medication-request-list__title">
      Últimas prescripciones creadas
    </h5>
    <div v-if="displayed && getWidth() < 768">
      <button class="btn btn-primary" type="button" v-on:click="displayed = false">
          Ver Filtros
        </button>
    </div>
    <form class="medication-request-list-view__filters row" @submit.prevent="handleFiltersFormSubmit" v-else>
      <div class="col-md-3">
        <form-group
          error-key="patientRut"
          for-id="patient-id"
          label="Run/Nro. Documento Paciente">
          <app-rut-input id="patient-id" v-model="filters.patientRut" class="form-control" :foreig="true" />
        </form-group>
      </div>
      <div class="col-sm-3">
        <form-group
          error-key="status"
          for-id="status"
          label="Estado">
          <el-select
            ref="el-select"
            v-model="filters.status"
            clearable
            placeholder="Todos"
            class="app-medication-search">
            <el-option
              v-for="(statusLabel, statusCode) in filterableMedicationRequestStatus"
              :key="`status-${statusCode}`"
              :label="statusLabel"
              :value="statusCode" />
          </el-select>
        </form-group>
      </div>
      <div class="col-md-4">
        <form-group label="Fecha de Creación" for-id="medication-timing-bounds-period">
          <el-date-picker
            :value="filters.boundPeriod"
            type="daterange"
            clearable
            range-separator="/"
            value-format="dd-MM-yyyy"
            start-placeholder="Fecha de Inicio"
            end-placeholder="Fecha de Termino"
            @input="handleBoundPeriodInput" />
        </form-group>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary" type="submit">
          Buscar
        </button>
      </div>
    </form>


    <div v-loading="fetchingMedicationRequests || cancelingPrescription" class="medication-request-list__content">



      <table class="table" v-if="getWidth() >= 768">
        <thead>
          <tr>
            <th>Paciente</th>
            <th>Estado</th>
            <th>Id Prescripción</th>
            <th>Fecha Creación</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="computedPagination.total > 0">
          <tr v-for="(medicationRequest, id) in medicationRequests" :key="`row-${id}`">
            <td>{{ medicationRequest[0].subject.display }}</td>
            <td><span class="badge" :class="`medication-request-badge__${medicationRequest[0].status}`">{{ medicationRequestStatusDisplay(medicationRequest[0].status) }}</span></td>
            <td>{{ medicationRequest[0].groupIdentifier.value.match(/(.{5})/g).join("-") }}</td>
            <td>{{ medicationRequest[0].authoredOn | dateTime }}</td>
            <td nowrap>
              <div class="btn-group" role="group">
                <button class="btn btn-sm btn-success" type="button" @click="handleClickShowMedicationRequest(id)">
                  <i class="fas fa-eye" /> Ver
                </button>
                <button
                  v-if="medicationRequest[0].status !== 'cancelled'"
                  class="btn btn-sm btn-danger"
                  type="button"
                  @click="handleClickCancelMedicationRequest(id)">
                  <i class="fas fa-ban" /> Anular
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center table-warning" colspan="5">
              No se han encontrado prescripciones
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <div v-if="displayed && !fetchingMedicationRequests">
          <div class ="prescription-list-item mt-3" v-for="(medicationRequest, id) in medicationRequests" :key="`row-${id}`">
            <div class="prescription-list-item__header">
              <label class="prescription-list-item__title" >
              <span class="badge" :class="`medication-request-badge__${medicationRequest[0].status}`">{{ medicationRequestStatusDisplay(medicationRequest[0].status) }}</span>
              </label>
            </div>
            <div class="row">
              <div class = "col-md-12">
                <p>
                  Paciente <br>
                  <strong>{{ medicationRequest[0].subject.display }}</strong>
                </p>
                <p>
                  ID Prescripción <br>
                  <strong>{{ medicationRequest[0].groupIdentifier.value }}</strong>
                </p>
                <p>
                  Fecha creación <br>
                  <strong>{{ medicationRequest[0].authoredOn | dateTime }}</strong>
                </p>
              </div>
            </div>
            <div class = "row ">
              <div class = "col-6">
                <button class="btn btn-sm btn-success btn-block" type="button" @click="handleClickShowMedicationRequest(id)">
                  <i class="fas fa-eye" /> Ver
                </button>
              </div>
              <div class = "col-6">
                  <button
                    v-if="medicationRequest[0].status !== 'cancelled'"
                    class="btn btn-sm btn-danger btn-block"
                    type="button"
                    @click="handleClickCancelMedicationRequest(id)">
                    <i class="fas fa-ban" /> Anular
                  </button>
              </div>
            </div>
          </div>
          <div v-if="computedPagination.total == 0" class="alert alert-warning mt-2 text-center" role="alert">
            No se han encontrado prescripciones

          </div>
        </div>
      </div>

      <el-pagination
        v-if="computedPagination.total > 0 && getWidth() >= 768"
        background
        layout="prev, pager, next"
        class="text-center"
        :disabled="fetchingMedicationRequests"
        :total="computedPagination.total"
        :page-size="computedPagination.pageSize"
        @current-change="handlePageChange" />
      <el-pagination
        v-if="computedPagination.total > 0 && getWidth() < 768 && displayed"
        small
        background
        layout="prev, pager, next"
        class="text-center"
        :disabled="fetchingMedicationRequests"
        :total="computedPagination.total"
        :page-size="computedPagination.pageSize"
        @current-change="handlePageChange" />
    </div>
    <prescription-preview-dialog
      :visible="showPrescriptionDialog"
      :prescription-id="medicationRequestId"
      @close-dialog="handleCloseDialog" />
  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import PrescriptionPreviewDialog from '@/components/prescription/PrescriptionPreviewDialog';
import _get from 'lodash/get';
import _pick from 'lodash/pick';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import AppRutInput from '@/components/AppRutInput';
import medicationRequestStatus from '@/fhir-definitions/medication-request-status';

dayjs.extend(customParseFormat);

export default {
  name: 'MedicationRequestListView',
  components: {
    AppRutInput,
    PrescriptionPreviewDialog,
    FormGroup
  },
  data() {
    return {
      medicationRequests: {},
      fetchingMedicationRequests: false,
      cancelingPrescription: false,
      showPrescriptionDialog: false,
      medicationRequestId: '',
      pagination: {
        total: 0,
        limit: 10,
        offset: 0
      },
      displayed: true,
      filters: {
        status: '',
        patientRut: '',
        boundPeriod: ['', '']
      }
    };
  },
  computed: {
    filterableMedicationRequestStatus() {
      return _pick(medicationRequestStatus, ['active', 'cancelled']);
    },
    computedPagination() {
      return {
        total: this.pagination.total,
        page: this.pagination.offset === 0 ? 1 : (this.pagination.limit / this.pagination.offset) + 1,
        pageSize: this.pagination.limit
      };
    },
    preparedFilters() {
      let filters = JSON.parse(JSON.stringify(this.filters));
      if (!filters.boundPeriod) {
        filters.boundPeriod = ['', ''];
      }
      filters.boundPeriod[0] = filters.boundPeriod[0] ? dayjs(filters.boundPeriod[0], 'DD-MM-YYYY').format('YYYY-MM-DD') : '';
      filters.boundPeriod[1] = filters.boundPeriod[1] ? dayjs(filters.boundPeriod[1], 'DD-MM-YYYY').format('YYYY-MM-DD') : '';
      return filters;
    },
    width(){
      return this.getWidth();
    }
  },
  created() {
    this.fetchPrescriptions();
  },
  methods: {
    getWidth(){
      return document.body.clientWidth;
    },
    handleFiltersFormSubmit() {
      this.displayed = true;
      this.resetPagination();
      this.fetchPrescriptions();
    },
    handleBoundPeriodInput(boundPeriod) {
      this.filters.boundPeriod = boundPeriod;
    },
    resetPagination() {
      this.pagination.total = 0;
      this.pagination.offset = 0;
    },
    handlePageChange(page) {
      this.pagination.offset = (page - 1) * this.pagination.limit;
      this.fetchPrescriptions();
    },
    medicationRequestStatusDisplay(status) {
      return medicationRequestStatus[status];
    },
    fetchPrescriptions() {
      this.fetchingMedicationRequests = true;
      this.$store.dispatch('fetchPrescriptions', {
        ...this.pagination,
        ...this.preparedFilters
      })
        .then(response => {
          this.medicationRequests = response.data;
          this.pagination.total = _get(response, 'meta.total', 0);
        })
        .finally(() => {
          this.fetchingMedicationRequests = false;
        });
    },
    handleClickShowMedicationRequest(medicationRequestId) {
      this.medicationRequestId = medicationRequestId;
      this.showPrescriptionDialog = true;
    },
    handleClickCancelMedicationRequest(id) {
      this.$confirm(`Está seguro que desea anular la prescripción [${id}]`)
        .then(() => {
          this.cancelingPrescription = true;
          this.$store.dispatch('cancelMedicationRequest', id)
            .then(response => {
              this.$message({
                message: response.message,
                type: 'success'
              });
            })
            .finally(() => {
              this.fetchPrescriptions();
              this.cancelingPrescription = false;
            });
        })
        .catch(() => {});
    },
    handleCloseDialog() {
      this.showPrescriptionDialog = false;
      this.medicationRequestId = '';
    }
  }
};
</script>

<style lang="scss">
.medication-request-list-view {
  background-color: $--color-white;
  border-radius: $--border-radius-base;
  padding: $--spacing-6;
  margin-top: $--spacing-4;
  &__title {
    color: $--color-blue;
    margin: 0 0 $--spacing-4 0;
  }

  td:last-child {
    i {
      transition: color 0.2s linear;
    }
  }

  &__filters {
    .btn-primary {
      margin-top: 2rem;
    }
  }
}

.prescription-list-item {
  position: relative;
  padding: $--spacing-6;
  border: 1px solid #D2D9E1;
  border-radius: $--border-radius-base;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.06);
  &__title {
    display: flex;
    margin-bottom: 0;
    align-items: center;
    input[type="checkbox"] {
      margin-right: 5px;
    }
    h4 {
      margin: 0;
    }
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
